import { useState } from "react";
import styles from "./Toggle.module.scss";

const Toggle = ({ theme = "blue", checked = false, onChange }) => {
  const [isToggled, setIsToggled] = useState(checked);

  const handleToggle = () => {
    const newState = !isToggled;
    setIsToggled(newState);
    if (onChange) {
      onChange(newState);
    }
  };

  const themeClass = theme === "yellow" ? styles.yellow : "";

  return (
    <label className={`${styles.toggleSwitch} ${themeClass}`}>
      <input type="checkbox" checked={isToggled} onChange={handleToggle} />
      <span className={`${styles.slider} ${themeClass}`}></span>
    </label>
  );
};

export default Toggle;